<template>
  <div class="CarmichaelMake">
    <mu-tabs :value.sync="active"
             class="tab"
             inverse
             color="#3B9CFD"
             indicator-color="#3B9CFD"
             center>
      <mu-tab>卡密预约</mu-tab>
    </mu-tabs>

    <div class="main">

      <mu-form ref="form" :model="form" v-show="active === 0 " >
        <mu-form-item label="卡号" prop="cardNo" :rules="rules.cardNoRules" label-float icon="credit_card">
          <mu-text-field v-model="form.cardNo" @keyup.enter.native=onSubmit(form) ></mu-text-field>
        </mu-form-item>
        <mu-form-item label="卡密" prop="cardPassword" :rules="rules.cardPasswordRules" label-float icon="lock">
          <mu-text-field v-model="form.cardPassword" @keyup.enter.native=onSubmit(form) :action-icon="visibility ? 'visibility_off' : 'visibility'"
                         :action-click="() => (visibility = !visibility)" :type="visibility ? 'text' : 'password'"></mu-text-field>
        </mu-form-item>
        <mu-form-item>
          <mu-button @click="onSubmit(form)" style="width: 100%; height: 52px;" round color="primary">确定</mu-button>
        </mu-form-item>
      </mu-form>

      <div class="tips">还没有购买 <span @click="tipClick()" >去购买</span></div>

    </div>

  </div>
</template>

<script>
export default {
  name: "CarmichaelMake",
  data() {
    return{
      active: 0,
      form: {
        cardNo: null,
        cardPassword: null,
      },
      rules: {
        cardNoRules: [
          { validate: (val) => !!val, message: '必须填写卡号'},
        ],
        cardPasswordRules: [
          { validate: (val) => !!val, message: '必须填写卡密'},
        ],
      },
      visibility: false
    }
  },
  created() {
    this.$isIos();

    // if(!this.$store.state.token) {
    //   this.$auth();
    // }


  },
  mounted() {

  },
  methods: {
    onSubmit(formName) {
      this.$refs.form.validate()
          .then(res => {
            if(res) {
              this.$post("physicalCard",formName)
                .then(res => {
                  if(res) {
                    console.log(res.data);

                    if(res.data.cardUsed == 0) {

                      // 套餐
                      this.$router.push({
                        path: "/MakeSetMeal",
                        query: {
                          id: res.data.productId,
                          // price: res.data.price,
                          price: 0,
                          name: res.data.productName,
                          isMake: false,
                          cardNo: res.data.cardNo
                        }
                      })

                    }else {

                      this.$router.push({
                        path: "/OrderDeta",
                        query: {
                          id: res.data.orderId
                        }
                      })

                    }

                  }
                })
            }
          })
    },
    tipClick() {
      this.$router.push({
        path: "/hot"
      })
    }
  }
}
</script>

<style lang="less" scoped>
    @import "../../style/Make/CarmichaelMake";
</style>
